import { ChangeDetectionStrategy, Component, input, ViewEncapsulation } from '@angular/core';
import { ColumnConfigEx, ColumnDefinitionEx } from "../../../../@core/types/column-config-types-extended";
import { applySearchRule } from '../../../../@core/utils/search-input-helper';
import { DiscountGroupProductGroupRelation, DiscountGroupProductGroupRelationSearchInput, Operator, ProductGroup } from "../../../../generated/generated-types";
import { BaseListWrapperComponent } from '../../../../shared/components/base-list-wrapper/base-list-wrapper.component';
import { NewBaseListComponent } from "../../../../shared/components/new-base-list-component/new-base-list-component";
import { ProductGroupDropDownComponent } from "../../controls/product-group-drop-down/product-group-drop-down.component";
import { DiscountGroupProductGroupRelationService } from "../../services/discount-group-product-group-relation.service";

@Component({
  selector: 'app-discount-group-product-group-relation-widget',
  template: `<app-base-list-wrapper [baseListComponent]="this" />`,
  encapsulation: ViewEncapsulation.Emulated,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    BaseListWrapperComponent,
  ]
})
export class DiscountGroupProductGroupRelationWidgetComponent extends NewBaseListComponent<DiscountGroupProductGroupRelation> {

  discountGroupId = input<string>();

  constructor(
    discountGroupProductGroupRelationService: DiscountGroupProductGroupRelationService,
  ) {
    super("DiscountGroupProductGroupRelation", discountGroupProductGroupRelationService);

    this.addInDetail = false;
    this.noCopy = true;
    this.noBaseEdit = true;
    this.inlineEditMode = true;
  }

  override getSearchInputForQuery(): DiscountGroupProductGroupRelationSearchInput {
    let si: DiscountGroupProductGroupRelationSearchInput = super.getSearchInputForQuery();

    applySearchRule(si, {
      field: "discountGroupId",
      operator: Operator.equal,
      value: this.discountGroupId()
    });

    return si;
  }

  protected override setColumnConfig(colConfig: ColumnConfigEx): void {
    let productGroupCol: ColumnDefinitionEx = colConfig.columns.find(x => x.field === 'productGroup.identifier' || (x.prop === "identifier" && x.entityType === 'ProductGroup'));
    if (productGroupCol) {
      productGroupCol.getEditComponent = () => ProductGroupDropDownComponent;
      productGroupCol.editComponentCreated = async (c: ProductGroupDropDownComponent, rowData: any, _colDef: ColumnDefinitionEx) => {
        if (rowData?.productGroup)
          c.setModel(rowData.productGroup);
        else if (rowData?.productGroupId) {
          await c.loadItemByIdAndSetSelected(rowData.productGroupId);
          this.cdRef.detectChanges();
        }

        c.value.subscribe(async (x: ProductGroup) => {
          rowData.productGroupId = x?.id;
        });
      }
    }

    super.setColumnConfig(colConfig);
  }

  override saveInCRUDService(rowData: DiscountGroupProductGroupRelation): Promise<DiscountGroupProductGroupRelation> {
    return super.saveInCRUDService({ ...rowData, discountGroupId: this.discountGroupId() });
  }
}
